(function () {
  var wrapper = document.getElementById('component-pricing-table');
  if (!wrapper) return;

  var table = wrapper.querySelector('#cpt-table');
  var tbody = table.querySelector('tbody');
  var cardsWrapper = wrapper.querySelector('#cpt-cards');
  var searchInput = wrapper.querySelector('#cpt-search-input');
  var headers = wrapper.querySelectorAll('.cpt-sortable');

  function getRows() {
    return Array.prototype.slice.call(tbody.querySelectorAll('tr:not(.cpt-empty-row)'));
  }

  function getCards() {
    if (!cardsWrapper) return [];
    return Array.prototype.slice.call(cardsWrapper.querySelectorAll('.cpt-card-item'));
  }

  // ---- Search ----
  if (searchInput) {
    searchInput.addEventListener('input', function () {
      var term = searchInput.value.trim().toLowerCase();

      getRows().forEach(function (row) {
        var partName = row.children[1].textContent.toLowerCase();
        var partCode = row.children[2].textContent.toLowerCase();
        var match = partName.indexOf(term) !== -1 || partCode.indexOf(term) !== -1;
        row.style.display = match ? '' : 'none';
      });

      getCards().forEach(function (card) {
        var name = card.querySelector('.cpt-card-item__name').textContent.toLowerCase();
        var code = card.querySelectorAll('.cpt-card-item__row span:last-child')[0].textContent.toLowerCase();
        var match = name.indexOf(term) !== -1 || code.indexOf(term) !== -1;
        card.style.display = match ? '' : 'none';
      });
    });
  }

  // ---- Column sorting (desktop table; also reorders cards by matching sort-order) ----
  var sortState = { key: null, asc: true };

  headers.forEach(function (th, colIndex) {
    th.addEventListener('click', function () {
      var type = th.getAttribute('data-sort');
      var asc = sortState.key === colIndex ? !sortState.asc : true;
      sortState = { key: colIndex, asc: asc };

      var rows = getRows();
      rows.sort(function (a, b) {
        var aVal = a.children[colIndex].textContent.trim();
        var bVal = b.children[colIndex].textContent.trim();

        if (type === 'number') {
          aVal = parseFloat(aVal.replace(/[^0-9.-]/g, '')) || 0;
          bVal = parseFloat(bVal.replace(/[^0-9.-]/g, '')) || 0;
          return asc ? aVal - bVal : bVal - aVal;
        }
        if (type === 'index') {
          aVal = parseInt(aVal, 10) || 0;
          bVal = parseInt(bVal, 10) || 0;
          return asc ? aVal - bVal : bVal - aVal;
        }
        return asc ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal);
      });

      rows.forEach(function (row) {
        tbody.appendChild(row);
      });

      // Reorder cards to match table row order (by part name, 2nd column = index 1)
      if (cardsWrapper) {
        var cards = getCards();
        var order = rows.map(function (r) { return r.children[1].textContent.trim(); });
        cards.sort(function (a, b) {
          var aName = a.querySelector('.cpt-card-item__name').textContent.trim();
          var bName = b.querySelector('.cpt-card-item__name').textContent.trim();
          return order.indexOf(aName) - order.indexOf(bName);
        });
        cards.forEach(function (card) {
          cardsWrapper.appendChild(card);
        });
      }
    });
  });
})();